import { AlertService } from './alert.service';
import { ErrorLoggingService } from './error-logging.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  // Guards the forced-logout flow so that a burst of concurrent 401s (several
  // requests fire per navigation) triggers a single alert + redirect instead of
  // stacking alerts and toggling loginStatus repeatedly — which made the
  // login/logout button flicker "várias vezes muito rápido".
  private sessionLogoutInProgress = false;

  constructor(
    private alertService: AlertService,
    private errorLoggingService: ErrorLoggingService
  ) {}

  async errorHandling(message: string, error?: any) {
    // Send error to logging service
    /* try {
      await this.errorLoggingService.logError(message, error);
    } catch (loggingError) {
      console.error('Failed to log error to service:', loggingError);
    } */

    if (
      message === 'Token expired. Please refresh your authentication.' ||
      message ===
        'Firebase ID token has expired. Get a fresh ID token from your client app and try again (auth/id-token-expired). See https://firebase.google.com/docs/auth/admin/verify-id-tokens for details on how to retrieve an ID token.' ||
      message ===
        'Firebase ID token has "kid" claim which does not correspond to a known public key. Most likely the ID token is expired, so get a fresh token from your client app and try again.'
    ) {
      // Only run the logout flow once per session-expiry burst.
      if (this.sessionLogoutInProgress) return;
      this.sessionLogoutInProgress = true;

      // Mark user as logged out
      localStorage.setItem('loginStatusDB', JSON.stringify(false));

      // Show warning and then send user to home page with storage cleared
      this.alertService.presentAlert(
        'Seu login foi expirado, entre novamente.',
        'warning-outline',
        'color-wn',
        'home'
      );

      setTimeout(() => {
        localStorage.clear();
        // Keep explicit logged-out flag after clearing
        localStorage.setItem('loginStatusDB', JSON.stringify(false));
        // Redirect to home; HomePage will open the address modal automatically
        // when there is no saved address in localStorage.
        location.replace('home');
      }, 4000);

      return;
    }
    if (message === "Cannot read property 'uid' of null") {
      if (this.sessionLogoutInProgress) return;
      this.sessionLogoutInProgress = true;
      localStorage.setItem('loginStatusDB', JSON.stringify(false));
      this.alertService.presentAlert(
        'Você está deslogado, por favor faça login.',
        'warning-outline',
        'color-wn',
        'home'
      );
      return;
    }
    if (message === 'First argument to verifyIdToken() must be a Firebase ID token string.') {
      if (this.sessionLogoutInProgress) return;
      this.sessionLogoutInProgress = true;
      localStorage.setItem('loginStatusDB', JSON.stringify(false));
      this.alertService.presentAlert(
        'Infezmente houve um erro com sua autenticação, entre novamente.',
        'warning-outline',
        'color-wn',
        'home'
      );
      return;
    }
    if (typeof message === 'string' && message.includes('Não há estoque suficiente do produto')) {
      this.alertService.presentAlert(message, 'warning-outline', 'color-wn');
      return;
    }
    if (typeof message === 'string' && message.length > 0) {
      this.alertService.presentAlert(message, 'warning-outline', 'color-wn');
      return;
    }
    this.alertService.presentAlert(
      'Infelizmente correu um erro inesperado.',
      'warning-outline',
      'color-wn',
      'home'
    );
    console.error('Final error logging:', message);
  }

  async customErrorHandling(message: string, error?: any) {
    // Log custom errors as well
    try {
      await this.errorLoggingService.logError(message, error);
    } catch (loggingError) {
      console.error('Failed to log custom error to service:', loggingError);
    }
    
    this.alertService.presentAlert(message, 'warning-outline', 'color-wn');
  }
}
